import cn from 'clsx'

const Input = ({ className, mb = 'mb-4', ...props }) => {
  return (
    <input className={cn(className, 'w-full bg-transparent border-b text-10 py-2 outline-none border-b-border', mb)} {...props} />
  )
}

export default Input
